import { c as _c } from "react/compiler-runtime";
import { type Address, type ChainId, ChainUtils } from '@morpho-org/blue-sdk';
import { cn } from '@morpho-org/ui-v6/utils';
import { Icon } from '@repo/ui';
import { Alert, Check, LoaderGradient } from '@repo/ui/icons';
import { abbreviateAddress } from '@repo/utils';
import { type ForwardedRef, forwardRef, memo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import './TransactionProgress.css';
export interface TransactionProgressProps {
  variant: TransactionProgressVariant;
  content?: string;
  address?: Address;
  chainId?: ChainId;
}
export type TransactionProgressVariant = 'loading' | 'success' | 'error';
const TransactionProgress = (t0, forwardedRef) => {
  const $ = _c(32);
  let address;
  let chainId;
  let content;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      variant: t1,
      content,
      address,
      chainId,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = address;
    $[2] = chainId;
    $[3] = content;
    $[4] = props;
    $[5] = t1;
  } else {
    address = $[1];
    chainId = $[2];
    content = $[3];
    props = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "loading" : t1;
  const t2 = variant === "error" ? "text-destructive-foreground" : "text-foreground";
  let t3;
  if ($[6] !== t2) {
    t3 = cn("text-sm", t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== content || $[9] !== t3) {
    t4 = <span className={t3}>{content}</span>;
    $[8] = content;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== address || $[12] !== chainId) {
    t5 = address && chainId ? <ButtonLink href={ChainUtils.getExplorerAddressUrl(chainId, address)} buttonProps={{
      variant: "secondary",
      size: "sm",
      label: abbreviateAddress(address)
    }} /> : null;
    $[11] = address;
    $[12] = chainId;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <div className="gap-xs flex flex-wrap items-center">{t4}{t5}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== variant) {
    t7 = variant === "loading" && <Icon icon={<LoaderGradient />} />;
    $[17] = variant;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== variant) {
    t8 = variant === "success" && <div className="transaction-progress-check-gradient ml-auto flex size-5 rounded-full"><Icon className="text-white" icon={<Check />} /></div>;
    $[19] = variant;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== variant) {
    t9 = variant === "error" && <Icon className="text-destructive-foreground ml-auto" icon={<Alert />} />;
    $[21] = variant;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t6 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className="flex justify-between">{t6}{t7}{t8}{t9}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== forwardedRef || $[29] !== props || $[30] !== t10) {
    t11 = <div className="flex w-full flex-col gap-[16px]" ref={forwardedRef} {...props}>{t10}</div>;
    $[28] = forwardedRef;
    $[29] = props;
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default memo(forwardRef(TransactionProgress));